import { FreightService } from '@prisma/client';

import { QuotesList } from '../components/QuotesList';
import { useCurrentRequest } from '../hooks/useCurrentRequest';

export const InlandQuotesScreen = () => {
  const { request, inlandQuotes, isLoadingQuotes: isLoading } = useCurrentRequest();

  return <QuotesList request={request} quotes={inlandQuotes} service={FreightService.EXW} isLoading={isLoading} />;
};
